import { createIcon } from './Icon';
import AirplaneTakeoffSvg from './svg/AirplaneTakeoff.svg?react';
import AirplaySvg from './svg/Airplay.svg?react';
import ArrowsCounterClockwiseSvg from './svg/ArrowsCounterClockwise.svg?react';
import ArrowUpSvg from './svg/ArrowUp.svg?react';
import BarbellSvg from './svg/Barbell.svg?react';
import BatteryFullSvg from './svg/BatteryFull.svg?react';
import BatteryLowSvg from './svg/BatteryLow.svg?react';
import BellSvg from './svg/Bell.svg?react';
import BinocularsSvg from './svg/Binoculars.svg?react';
import BlurSvg from './svg/Blur.svg?react';
import BookOpenSvg from './svg/BookOpen.svg?react';
import BookOpenTextSvg from './svg/BookOpenText.svg?react';
import BooksSvg from './svg/Books.svg?react';
import BrainSvg from './svg/Brain.svg?react';
import BriefcaseSvg from './svg/Briefcase.svg?react';
import BuildingsSvg from './svg/Buildings.svg?react';
import CakeSvg from './svg/Cake.svg?react';
import CalendarBlankSvg from './svg/CalendarBlank.svg?react';
import CalendarCheckSvg from './svg/CalendarCheck.svg?react';
import CalendarDotsSvg from './svg/CalendarDots.svg?react';
import CaretDownSvg from './svg/CaretDown.svg?react';
import CaretLeftSvg from './svg/CaretLeft.svg?react';
import CaretRightSvg from './svg/CaretRight.svg?react';
import CaretUpSvg from './svg/CaretUp.svg?react';
import CaretUpDownSvg from './svg/CaretUpDown.svg?react';
import ChartBarSvg from './svg/ChartBar.svg?react';
import ChartLineUpSvg from './svg/ChartLineUp.svg?react';
import ChartPieSliceSvg from './svg/ChartPieSlice.svg?react';
import ChatCircleSvg from './svg/ChatCircle.svg?react';
import ChatsCircleSvg from './svg/ChatsCircle.svg?react';
import CheckSvg from './svg/Check.svg?react';
import CheckBoldSvg from './svg/CheckBold.svg?react';
import CheckCircleSvg from './svg/CheckCircle.svg?react';
import ChecksSvg from './svg/Checks.svg?react';
import CheckThinSvg from './svg/CheckThin.svg?react';
import CircleDashedSvg from './svg/CircleDashed.svg?react';
import CircleNotchSvg from './svg/CircleNotch.svg?react';
import CircleProgressSvg from './svg/CircleProgress.svg?react';
import ClipboardTextSvg from './svg/ClipboardText.svg?react';
import ClockSvg from './svg/Clock.svg?react';
import ClockCounterClockwiseSvg from './svg/ClockCounterClockwise.svg?react';
import ClosedCaptioningSvg from './svg/ClosedCaptioning.svg?react';
import CoffeeSvg from './svg/Coffee.svg?react';
import CompassSvg from './svg/Compass.svg?react';
import ConfettiSvg from './svg/Confetti.svg?react';
import CopySvg from './svg/Copy.svg?react';
import CrownSvg from './svg/Crown.svg?react';
import CurrencyDollarSvg from './svg/CurrencyDollar.svg?react';
import DoorOpenSvg from './svg/DoorOpen.svg?react';
import DotsSixVerticalSvg from './svg/DotsSixVertical.svg?react';
import DotsThreeSvg from './svg/DotsThree.svg?react';
import DownloadSimpleSvg from './svg/DownloadSimple.svg?react';
import EarSvg from './svg/Ear.svg?react';
import EnvelopeSimpleSvg from './svg/EnvelopeSimple.svg?react';
import EyeSvg from './svg/Eye.svg?react';
import EyeSlashSvg from './svg/EyeSlash.svg?react';
import FileAudioSvg from './svg/FileAudio.svg?react';
import FingerprintSvg from './svg/Fingerprint.svg?react';
import FireSvg from './svg/Fire.svg?react';
import FlagSvg from './svg/Flag.svg?react';
import FlaskSvg from './svg/Flask.svg?react';
import GaugeSvg from './svg/Gauge.svg?react';
import GearSvg from './svg/Gear.svg?react';
import GiftSvg from './svg/Gift.svg?react';
import GlobeHemisphereWestSvg from './svg/GlobeHemisphereWest.svg?react';
import GoogleLogoSvg from './svg/GoogleLogo.svg?react';
import GraduationCapSvg from './svg/GraduationCap.svg?react';
import HandSvg from './svg/Hand.svg?react';
import HandHeartSvg from './svg/HandHeart.svg?react';
import HandshakeSvg from './svg/Handshake.svg?react';
import HandWavingSvg from './svg/HandWaving.svg?react';
import HeartSvg from './svg/Heart.svg?react';
import HourglassSvg from './svg/Hourglass.svg?react';
import HouseSvg from './svg/House.svg?react';
import InfoSvg from './svg/Info.svg?react';
import KeySvg from './svg/Key.svg?react';
import KeyboardSvg from './svg/Keyboard.svg?react';
import LeafSvg from './svg/Leaf.svg?react';
import LifebuoySvg from './svg/Lifebuoy.svg?react';
import LightbulbSvg from './svg/Lightbulb.svg?react';
import LightningSvg from './svg/Lightning.svg?react';
import LinkSvg from './svg/Link.svg?react';
import ListChecksSvg from './svg/ListChecks.svg?react';
import LockSvg from './svg/Lock.svg?react';
import MagicWandSvg from './svg/MagicWand.svg?react';
import MagnifyingGlassSvg from './svg/MagnifyingGlass.svg?react';
import MapPinSvg from './svg/MapPin.svg?react';
import MedalSvg from './svg/Medal.svg?react';
import MegaphoneSvg from './svg/Megaphone.svg?react';
import MicrophoneSvg from './svg/Microphone.svg?react';
import MicrophoneSlashSvg from './svg/MicrophoneSlash.svg?react';
import MicrosoftLogoSvg from './svg/MicrosoftLogo.svg?react';
import MinusRectangleSvg from './svg/MinusRectangle.svg?react';
import MonitorSvg from './svg/Monitor.svg?react';
import MonitorArrowUpSvg from './svg/MonitorArrowUp.svg?react';
import MoonSvg from './svg/Moon.svg?react';
import MountainsSvg from './svg/Mountains.svg?react';
import NatalieMarkSvg from './svg/NatalieMark.svg?react';
import NotebookSvg from './svg/Notebook.svg?react';
import PasswordSvg from './svg/Password.svg?react';
import PathSvg from './svg/Path.svg?react';
import PauseSvg from './svg/Pause.svg?react';
import PencilSimpleSvg from './svg/PencilSimple.svg?react';
import PersonSimpleRunSvg from './svg/PersonSimpleRun.svg?react';
import PhoneDisconnectSvg from './svg/PhoneDisconnect.svg?react';
import PiggyBankSvg from './svg/PiggyBank.svg?react';
import PlantSvg from './svg/Plant.svg?react';
import PlaySvg from './svg/Play.svg?react';
import PlusSvg from './svg/Plus.svg?react';
import PresentationChartSvg from './svg/PresentationChart.svg?react';
import ProhibitSvg from './svg/Prohibit.svg?react';
import PuzzlePieceSvg from './svg/PuzzlePiece.svg?react';
import QuestionSvg from './svg/Question.svg?react';
import QuotesSvg from './svg/Quotes.svg?react';
import RecordSvg from './svg/Record.svg?react';
import RocketSvg from './svg/Rocket.svg?react';
import ScalesSvg from './svg/Scales.svg?react';
import SealCheckSvg from './svg/SealCheck.svg?react';
import ShieldCheckSvg from './svg/ShieldCheck.svg?react';
import SignInSvg from './svg/SignIn.svg?react';
import SignOutSvg from './svg/SignOut.svg?react';
import SignpostSvg from './svg/Signpost.svg?react';
import SmileySvg from './svg/Smiley.svg?react';
import SmileyMehSvg from './svg/SmileyMeh.svg?react';
import SmileySadSvg from './svg/SmileySad.svg?react';
import SparkleSvg from './svg/Sparkle.svg?react';
import SpeakerSimpleHighSvg from './svg/SpeakerSimpleHigh.svg?react';
import SpeakerSimpleSlashSvg from './svg/SpeakerSimpleSlash.svg?react';
import StarSvg from './svg/Star.svg?react';
import StopSvg from './svg/Stop.svg?react';
import StorefrontSvg from './svg/Storefront.svg?react';
import SunSvg from './svg/Sun.svg?react';
import TagSvg from './svg/Tag.svg?react';
import TargetSvg from './svg/Target.svg?react';
import TextAlignLeftSvg from './svg/TextAlignLeft.svg?react';
import ThumbsDownSvg from './svg/ThumbsDown.svg?react';
import ThumbsUpSvg from './svg/ThumbsUp.svg?react';
import TimerSvg from './svg/Timer.svg?react';
import ToolboxSvg from './svg/Toolbox.svg?react';
import TreeStructureSvg from './svg/TreeStructure.svg?react';
import TrophySvg from './svg/Trophy.svg?react';
import TruckSvg from './svg/Truck.svg?react';
import UploadSimpleSvg from './svg/UploadSimple.svg?react';
import UserSvg from './svg/User.svg?react';
import UserCircleMinusSvg from './svg/UserCircleMinus.svg?react';
import UserCirclePlusSvg from './svg/UserCirclePlus.svg?react';
import UserGearSvg from './svg/UserGear.svg?react';
import UserRectangleSvg from './svg/UserRectangle.svg?react';
import UsersSvg from './svg/Users.svg?react';
import UserSoundSvg from './svg/UserSound.svg?react';
import VideoCameraSvg from './svg/VideoCamera.svg?react';
import VideoCameraSlashSvg from './svg/VideoCameraSlash.svg?react';
import WalletSvg from './svg/Wallet.svg?react';
import WarningSvg from './svg/Warning.svg?react';
import WarningCircleSvg from './svg/WarningCircle.svg?react';
import WaveformSvg from './svg/Waveform.svg?react';
import WaveformActiveSvg from './svg/WaveformActive.svg?react';
import WrenchSvg from './svg/Wrench.svg?react';
import XSvg from './svg/X.svg?react';

/**
 * The Design System 2.0 icon set, one named export per glyph.
 *
 * Named exports only — tree-shakeable, and the idiom `src/icons` and `Dialog.tsx` already use.
 * There is deliberately no `<Icon name="…" />` prop API: nothing in the app resolves an icon by
 * string at runtime (`Alert`'s severity map works by putting named imports in the map), and a name
 * API would trade away tree-shaking for a consumer that does not exist. Add one when something
 * genuinely needs it, and price the loss then.
 *
 * The SOURCE of a glyph is an implementation detail. 148 of these are synthesised from Phosphor by
 * `scripts/generate-icons.mjs`; `CircleProgressIcon`, `DotsSixVerticalIcon`, `DotsThreeIcon`, `MinusRectangleIcon`,
 * `NatalieMarkIcon` and `WaveformActiveIcon` are Natter-drawn, and `GoogleLogoIcon` and `MicrosoftLogoIcon` are the providers' own multi-colour marks. Nothing at a call site can tell, which is the point — an icon can change source without touching a
 * consumer.
 *
 * Every export carries a `#__PURE__` annotation. Rollup currently tree-shakes the unused glyphs
 * without it — verified: `strokeWidth="3.2"` appears in no built chunk — but that rests on its own
 * side-effect analysis of a factory call re-exported through a barrel, which is a heuristic rather
 * than a guarantee. The annotation states the fact outright, so none of the icons can quietly start
 * riding into the main chunk on a bundler upgrade. A test asserts every export still has one.
 *
 * Hand-maintained alongside `icon-manifest.ts`, and the tests in `__tests__/icons.test.ts` assert
 * both directions: every manifest row has an SVG and an export here, and every SVG and every
 * export has a manifest row.
 *
 * FIVE NAMES COLLIDE with the legacy `icons` barrel: `ArrowUpIcon`, `CheckIcon`, `CopyIcon`,
 * `LinkIcon` and `PauseIcon`. The barrels are separate modules (`from 'icons'` vs `from '@natter-co/design-system'`), so this is
 * not a build break — but the legacy glyphs are Material-derived and look different, so a
 * mis-import is silent. In a file that imports both, alias:
 * `import { ArrowUpIcon as LegacyArrowUpIcon } from 'icons'`. See README.md.
 */

export const AirplaneTakeoffIcon = /*#__PURE__*/ createIcon(AirplaneTakeoffSvg, 'AirplaneTakeoffIcon');
export const AirplayIcon = /*#__PURE__*/ createIcon(AirplaySvg, 'AirplayIcon');
export const ArrowsCounterClockwiseIcon = /*#__PURE__*/ createIcon(
  ArrowsCounterClockwiseSvg,
  'ArrowsCounterClockwiseIcon'
);
export const ArrowUpIcon = /*#__PURE__*/ createIcon(ArrowUpSvg, 'ArrowUpIcon');
export const BarbellIcon = /*#__PURE__*/ createIcon(BarbellSvg, 'BarbellIcon');
export const BatteryFullIcon = /*#__PURE__*/ createIcon(BatteryFullSvg, 'BatteryFullIcon');
export const BatteryLowIcon = /*#__PURE__*/ createIcon(BatteryLowSvg, 'BatteryLowIcon');
export const BellIcon = /*#__PURE__*/ createIcon(BellSvg, 'BellIcon');
export const BinocularsIcon = /*#__PURE__*/ createIcon(BinocularsSvg, 'BinocularsIcon');
export const BlurIcon = /*#__PURE__*/ createIcon(BlurSvg, 'BlurIcon');
export const BookOpenIcon = /*#__PURE__*/ createIcon(BookOpenSvg, 'BookOpenIcon');
export const BookOpenTextIcon = /*#__PURE__*/ createIcon(BookOpenTextSvg, 'BookOpenTextIcon');
export const BooksIcon = /*#__PURE__*/ createIcon(BooksSvg, 'BooksIcon');
export const BrainIcon = /*#__PURE__*/ createIcon(BrainSvg, 'BrainIcon');
export const BriefcaseIcon = /*#__PURE__*/ createIcon(BriefcaseSvg, 'BriefcaseIcon');
export const BuildingsIcon = /*#__PURE__*/ createIcon(BuildingsSvg, 'BuildingsIcon');
export const CakeIcon = /*#__PURE__*/ createIcon(CakeSvg, 'CakeIcon');
export const CalendarBlankIcon = /*#__PURE__*/ createIcon(CalendarBlankSvg, 'CalendarBlankIcon');
export const CalendarCheckIcon = /*#__PURE__*/ createIcon(CalendarCheckSvg, 'CalendarCheckIcon');
export const CalendarDotsIcon = /*#__PURE__*/ createIcon(CalendarDotsSvg, 'CalendarDotsIcon');
export const CaretDownIcon = /*#__PURE__*/ createIcon(CaretDownSvg, 'CaretDownIcon');
export const CaretLeftIcon = /*#__PURE__*/ createIcon(CaretLeftSvg, 'CaretLeftIcon');
export const CaretRightIcon = /*#__PURE__*/ createIcon(CaretRightSvg, 'CaretRightIcon');
export const CaretUpIcon = /*#__PURE__*/ createIcon(CaretUpSvg, 'CaretUpIcon');
export const CaretUpDownIcon = /*#__PURE__*/ createIcon(CaretUpDownSvg, 'CaretUpDownIcon');
export const ChartBarIcon = /*#__PURE__*/ createIcon(ChartBarSvg, 'ChartBarIcon');
export const ChartLineUpIcon = /*#__PURE__*/ createIcon(ChartLineUpSvg, 'ChartLineUpIcon');
export const ChartPieSliceIcon = /*#__PURE__*/ createIcon(ChartPieSliceSvg, 'ChartPieSliceIcon');
export const ChatCircleIcon = /*#__PURE__*/ createIcon(ChatCircleSvg, 'ChatCircleIcon');
export const ChatsCircleIcon = /*#__PURE__*/ createIcon(ChatsCircleSvg, 'ChatsCircleIcon');
export const CheckIcon = /*#__PURE__*/ createIcon(CheckSvg, 'CheckIcon');
export const CheckBoldIcon = /*#__PURE__*/ createIcon(CheckBoldSvg, 'CheckBoldIcon');
export const CheckCircleIcon = /*#__PURE__*/ createIcon(CheckCircleSvg, 'CheckCircleIcon');
export const ChecksIcon = /*#__PURE__*/ createIcon(ChecksSvg, 'ChecksIcon');
export const CheckThinIcon = /*#__PURE__*/ createIcon(CheckThinSvg, 'CheckThinIcon');
export const CircleDashedIcon = /*#__PURE__*/ createIcon(CircleDashedSvg, 'CircleDashedIcon');
export const CircleNotchIcon = /*#__PURE__*/ createIcon(CircleNotchSvg, 'CircleNotchIcon');
export const CircleProgressIcon = /*#__PURE__*/ createIcon(CircleProgressSvg, 'CircleProgressIcon');
export const ClipboardTextIcon = /*#__PURE__*/ createIcon(ClipboardTextSvg, 'ClipboardTextIcon');
export const ClockIcon = /*#__PURE__*/ createIcon(ClockSvg, 'ClockIcon');
export const ClockCounterClockwiseIcon = /*#__PURE__*/ createIcon(
  ClockCounterClockwiseSvg,
  'ClockCounterClockwiseIcon'
);
export const ClosedCaptioningIcon = /*#__PURE__*/ createIcon(ClosedCaptioningSvg, 'ClosedCaptioningIcon');
export const CoffeeIcon = /*#__PURE__*/ createIcon(CoffeeSvg, 'CoffeeIcon');
export const CompassIcon = /*#__PURE__*/ createIcon(CompassSvg, 'CompassIcon');
export const ConfettiIcon = /*#__PURE__*/ createIcon(ConfettiSvg, 'ConfettiIcon');
export const CopyIcon = /*#__PURE__*/ createIcon(CopySvg, 'CopyIcon');
export const CrownIcon = /*#__PURE__*/ createIcon(CrownSvg, 'CrownIcon');
export const CurrencyDollarIcon = /*#__PURE__*/ createIcon(CurrencyDollarSvg, 'CurrencyDollarIcon');
export const DoorOpenIcon = /*#__PURE__*/ createIcon(DoorOpenSvg, 'DoorOpenIcon');
export const DotsSixVerticalIcon = /*#__PURE__*/ createIcon(DotsSixVerticalSvg, 'DotsSixVerticalIcon');
export const DotsThreeIcon = /*#__PURE__*/ createIcon(DotsThreeSvg, 'DotsThreeIcon');
export const DownloadSimpleIcon = /*#__PURE__*/ createIcon(DownloadSimpleSvg, 'DownloadSimpleIcon');
export const EarIcon = /*#__PURE__*/ createIcon(EarSvg, 'EarIcon');
export const EnvelopeSimpleIcon = /*#__PURE__*/ createIcon(EnvelopeSimpleSvg, 'EnvelopeSimpleIcon');
export const EyeIcon = /*#__PURE__*/ createIcon(EyeSvg, 'EyeIcon');
export const EyeSlashIcon = /*#__PURE__*/ createIcon(EyeSlashSvg, 'EyeSlashIcon');
export const FileAudioIcon = /*#__PURE__*/ createIcon(FileAudioSvg, 'FileAudioIcon');
export const FingerprintIcon = /*#__PURE__*/ createIcon(FingerprintSvg, 'FingerprintIcon');
export const FireIcon = /*#__PURE__*/ createIcon(FireSvg, 'FireIcon');
export const FlagIcon = /*#__PURE__*/ createIcon(FlagSvg, 'FlagIcon');
export const FlaskIcon = /*#__PURE__*/ createIcon(FlaskSvg, 'FlaskIcon');
export const GaugeIcon = /*#__PURE__*/ createIcon(GaugeSvg, 'GaugeIcon');
export const GearIcon = /*#__PURE__*/ createIcon(GearSvg, 'GearIcon');
export const GiftIcon = /*#__PURE__*/ createIcon(GiftSvg, 'GiftIcon');
export const GlobeHemisphereWestIcon = /*#__PURE__*/ createIcon(GlobeHemisphereWestSvg, 'GlobeHemisphereWestIcon');
export const GoogleLogoIcon = /*#__PURE__*/ createIcon(GoogleLogoSvg, 'GoogleLogoIcon');
export const GraduationCapIcon = /*#__PURE__*/ createIcon(GraduationCapSvg, 'GraduationCapIcon');
export const HandIcon = /*#__PURE__*/ createIcon(HandSvg, 'HandIcon');
export const HandHeartIcon = /*#__PURE__*/ createIcon(HandHeartSvg, 'HandHeartIcon');
export const HandshakeIcon = /*#__PURE__*/ createIcon(HandshakeSvg, 'HandshakeIcon');
export const HandWavingIcon = /*#__PURE__*/ createIcon(HandWavingSvg, 'HandWavingIcon');
export const HeartIcon = /*#__PURE__*/ createIcon(HeartSvg, 'HeartIcon');
export const HourglassIcon = /*#__PURE__*/ createIcon(HourglassSvg, 'HourglassIcon');
export const HouseIcon = /*#__PURE__*/ createIcon(HouseSvg, 'HouseIcon');
export const InfoIcon = /*#__PURE__*/ createIcon(InfoSvg, 'InfoIcon');
export const KeyIcon = /*#__PURE__*/ createIcon(KeySvg, 'KeyIcon');
export const KeyboardIcon = /*#__PURE__*/ createIcon(KeyboardSvg, 'KeyboardIcon');
export const LeafIcon = /*#__PURE__*/ createIcon(LeafSvg, 'LeafIcon');
export const LifebuoyIcon = /*#__PURE__*/ createIcon(LifebuoySvg, 'LifebuoyIcon');
export const LightbulbIcon = /*#__PURE__*/ createIcon(LightbulbSvg, 'LightbulbIcon');
export const LightningIcon = /*#__PURE__*/ createIcon(LightningSvg, 'LightningIcon');
export const LinkIcon = /*#__PURE__*/ createIcon(LinkSvg, 'LinkIcon');
export const ListChecksIcon = /*#__PURE__*/ createIcon(ListChecksSvg, 'ListChecksIcon');
export const LockIcon = /*#__PURE__*/ createIcon(LockSvg, 'LockIcon');
export const MagicWandIcon = /*#__PURE__*/ createIcon(MagicWandSvg, 'MagicWandIcon');
export const MagnifyingGlassIcon = /*#__PURE__*/ createIcon(MagnifyingGlassSvg, 'MagnifyingGlassIcon');
export const MapPinIcon = /*#__PURE__*/ createIcon(MapPinSvg, 'MapPinIcon');
export const MedalIcon = /*#__PURE__*/ createIcon(MedalSvg, 'MedalIcon');
export const MegaphoneIcon = /*#__PURE__*/ createIcon(MegaphoneSvg, 'MegaphoneIcon');
export const MicrophoneIcon = /*#__PURE__*/ createIcon(MicrophoneSvg, 'MicrophoneIcon');
export const MicrophoneSlashIcon = /*#__PURE__*/ createIcon(MicrophoneSlashSvg, 'MicrophoneSlashIcon');
export const MicrosoftLogoIcon = /*#__PURE__*/ createIcon(MicrosoftLogoSvg, 'MicrosoftLogoIcon');
export const MinusRectangleIcon = /*#__PURE__*/ createIcon(MinusRectangleSvg, 'MinusRectangleIcon');
export const MonitorIcon = /*#__PURE__*/ createIcon(MonitorSvg, 'MonitorIcon');
export const MonitorArrowUpIcon = /*#__PURE__*/ createIcon(MonitorArrowUpSvg, 'MonitorArrowUpIcon');
export const MoonIcon = /*#__PURE__*/ createIcon(MoonSvg, 'MoonIcon');
export const MountainsIcon = /*#__PURE__*/ createIcon(MountainsSvg, 'MountainsIcon');
export const NatalieMarkIcon = /*#__PURE__*/ createIcon(NatalieMarkSvg, 'NatalieMarkIcon');
export const NotebookIcon = /*#__PURE__*/ createIcon(NotebookSvg, 'NotebookIcon');
export const PasswordIcon = /*#__PURE__*/ createIcon(PasswordSvg, 'PasswordIcon');
export const PathIcon = /*#__PURE__*/ createIcon(PathSvg, 'PathIcon');
export const PauseIcon = /*#__PURE__*/ createIcon(PauseSvg, 'PauseIcon');
export const PencilSimpleIcon = /*#__PURE__*/ createIcon(PencilSimpleSvg, 'PencilSimpleIcon');
export const PersonSimpleRunIcon = /*#__PURE__*/ createIcon(PersonSimpleRunSvg, 'PersonSimpleRunIcon');
export const PhoneDisconnectIcon = /*#__PURE__*/ createIcon(PhoneDisconnectSvg, 'PhoneDisconnectIcon');
export const PiggyBankIcon = /*#__PURE__*/ createIcon(PiggyBankSvg, 'PiggyBankIcon');
export const PlantIcon = /*#__PURE__*/ createIcon(PlantSvg, 'PlantIcon');
export const PlayIcon = /*#__PURE__*/ createIcon(PlaySvg, 'PlayIcon');
export const PlusIcon = /*#__PURE__*/ createIcon(PlusSvg, 'PlusIcon');
export const PresentationChartIcon = /*#__PURE__*/ createIcon(PresentationChartSvg, 'PresentationChartIcon');
export const ProhibitIcon = /*#__PURE__*/ createIcon(ProhibitSvg, 'ProhibitIcon');
export const PuzzlePieceIcon = /*#__PURE__*/ createIcon(PuzzlePieceSvg, 'PuzzlePieceIcon');
export const QuestionIcon = /*#__PURE__*/ createIcon(QuestionSvg, 'QuestionIcon');
export const QuotesIcon = /*#__PURE__*/ createIcon(QuotesSvg, 'QuotesIcon');
export const RecordIcon = /*#__PURE__*/ createIcon(RecordSvg, 'RecordIcon');
export const RocketIcon = /*#__PURE__*/ createIcon(RocketSvg, 'RocketIcon');
export const ScalesIcon = /*#__PURE__*/ createIcon(ScalesSvg, 'ScalesIcon');
export const SealCheckIcon = /*#__PURE__*/ createIcon(SealCheckSvg, 'SealCheckIcon');
export const ShieldCheckIcon = /*#__PURE__*/ createIcon(ShieldCheckSvg, 'ShieldCheckIcon');
export const SignInIcon = /*#__PURE__*/ createIcon(SignInSvg, 'SignInIcon');
export const SignOutIcon = /*#__PURE__*/ createIcon(SignOutSvg, 'SignOutIcon');
export const SignpostIcon = /*#__PURE__*/ createIcon(SignpostSvg, 'SignpostIcon');
export const SmileyIcon = /*#__PURE__*/ createIcon(SmileySvg, 'SmileyIcon');
export const SmileyMehIcon = /*#__PURE__*/ createIcon(SmileyMehSvg, 'SmileyMehIcon');
export const SmileySadIcon = /*#__PURE__*/ createIcon(SmileySadSvg, 'SmileySadIcon');
export const SparkleIcon = /*#__PURE__*/ createIcon(SparkleSvg, 'SparkleIcon');
export const SpeakerSimpleHighIcon = /*#__PURE__*/ createIcon(SpeakerSimpleHighSvg, 'SpeakerSimpleHighIcon');
export const SpeakerSimpleSlashIcon = /*#__PURE__*/ createIcon(SpeakerSimpleSlashSvg, 'SpeakerSimpleSlashIcon');
export const StarIcon = /*#__PURE__*/ createIcon(StarSvg, 'StarIcon');
export const StopIcon = /*#__PURE__*/ createIcon(StopSvg, 'StopIcon');
export const StorefrontIcon = /*#__PURE__*/ createIcon(StorefrontSvg, 'StorefrontIcon');
export const SunIcon = /*#__PURE__*/ createIcon(SunSvg, 'SunIcon');
export const TagIcon = /*#__PURE__*/ createIcon(TagSvg, 'TagIcon');
export const TargetIcon = /*#__PURE__*/ createIcon(TargetSvg, 'TargetIcon');
export const TextAlignLeftIcon = /*#__PURE__*/ createIcon(TextAlignLeftSvg, 'TextAlignLeftIcon');
export const ThumbsDownIcon = /*#__PURE__*/ createIcon(ThumbsDownSvg, 'ThumbsDownIcon');
export const ThumbsUpIcon = /*#__PURE__*/ createIcon(ThumbsUpSvg, 'ThumbsUpIcon');
export const TimerIcon = /*#__PURE__*/ createIcon(TimerSvg, 'TimerIcon');
export const ToolboxIcon = /*#__PURE__*/ createIcon(ToolboxSvg, 'ToolboxIcon');
export const TreeStructureIcon = /*#__PURE__*/ createIcon(TreeStructureSvg, 'TreeStructureIcon');
export const TrophyIcon = /*#__PURE__*/ createIcon(TrophySvg, 'TrophyIcon');
export const TruckIcon = /*#__PURE__*/ createIcon(TruckSvg, 'TruckIcon');
export const UploadSimpleIcon = /*#__PURE__*/ createIcon(UploadSimpleSvg, 'UploadSimpleIcon');
export const UserIcon = /*#__PURE__*/ createIcon(UserSvg, 'UserIcon');
export const UserCircleMinusIcon = /*#__PURE__*/ createIcon(UserCircleMinusSvg, 'UserCircleMinusIcon');
export const UserCirclePlusIcon = /*#__PURE__*/ createIcon(UserCirclePlusSvg, 'UserCirclePlusIcon');
export const UserGearIcon = /*#__PURE__*/ createIcon(UserGearSvg, 'UserGearIcon');
export const UserRectangleIcon = /*#__PURE__*/ createIcon(UserRectangleSvg, 'UserRectangleIcon');
export const UsersIcon = /*#__PURE__*/ createIcon(UsersSvg, 'UsersIcon');
export const UserSoundIcon = /*#__PURE__*/ createIcon(UserSoundSvg, 'UserSoundIcon');
export const VideoCameraIcon = /*#__PURE__*/ createIcon(VideoCameraSvg, 'VideoCameraIcon');
export const VideoCameraSlashIcon = /*#__PURE__*/ createIcon(VideoCameraSlashSvg, 'VideoCameraSlashIcon');
export const WalletIcon = /*#__PURE__*/ createIcon(WalletSvg, 'WalletIcon');
export const WarningIcon = /*#__PURE__*/ createIcon(WarningSvg, 'WarningIcon');
export const WarningCircleIcon = /*#__PURE__*/ createIcon(WarningCircleSvg, 'WarningCircleIcon');
export const WaveformIcon = /*#__PURE__*/ createIcon(WaveformSvg, 'WaveformIcon');
export const WaveformActiveIcon = /*#__PURE__*/ createIcon(WaveformActiveSvg, 'WaveformActiveIcon');
export const WrenchIcon = /*#__PURE__*/ createIcon(WrenchSvg, 'WrenchIcon');
export const XIcon = /*#__PURE__*/ createIcon(XSvg, 'XIcon');
